/* eslint-disable class-methods-use-this */
import Comparison from '@/types/comparison';
import ComparisonItem from '@/types/comparison-item';
import { COMPARISON_ITEM_TYPES } from '@/utils/constants';
import { ComparisonItemCategory } from '@/redux/modules/types/comparison';
import { PortfolioResolutionStrategy } from './portfolio-resolution-strategy';

/**
 * Category-based portfolio resolution (legacy)
 * Uses ComparisonItemCategory.CURRENT and ComparisonItemCategory.RECOMMENDED
 *
 * This strategy resolves portfolios based on the `category` field on each ComparisonItem.
 * It's the original/legacy approach used before Account Sets were introduced.
 *
 * @example
 * const strategy = new CategoryBasedStrategy();
 * const currentPortfolios = strategy.getCurrentPortfolios(comparison);
 * // Returns all items where category === ComparisonItemCategory.CURRENT
 */
export class CategoryBasedStrategy implements PortfolioResolutionStrategy {
  getCurrentPortfolios(comparison: Comparison): ComparisonItem[] {
    return comparison.items.filter(item => item.type === COMPARISON_ITEM_TYPES.PORTFOLIO && item.category === ComparisonItemCategory.CURRENT);
  }

  getRecommendedPortfolios(comparison: Comparison): ComparisonItem[] {
    return comparison.items.filter(item => item.type === COMPARISON_ITEM_TYPES.PORTFOLIO && item.category === ComparisonItemCategory.RECOMMENDED);
  }

  getPrimaryRecommendedPortfolios(comparison: Comparison): ComparisonItem[] {
    // In category mode, all recommended are treated as primary
    return this.getRecommendedPortfolios(comparison);
  }

  isCurrentPortfolio(comparison: Comparison, item: ComparisonItem): boolean {
    return item.type === COMPARISON_ITEM_TYPES.PORTFOLIO && item.category === ComparisonItemCategory.CURRENT;
  }

  isRecommendedPortfolio(comparison: Comparison, item: ComparisonItem): boolean {
    return item.type === COMPARISON_ITEM_TYPES.PORTFOLIO && item.category === ComparisonItemCategory.RECOMMENDED;
  }

  areAllPortfoliosAssigned(comparison: Comparison): boolean {
    return comparison.items
      .filter(item => item.type === COMPARISON_ITEM_TYPES.PORTFOLIO)
      .every(item => item.category && [ComparisonItemCategory.CURRENT, ComparisonItemCategory.RECOMMENDED].includes(item.category));
  }
}
